module.exports = __webpack_public_path__ + "img/default-product-img.4b187454.png";